import React, { useState } from "react";
import { graphql, useStaticQuery, navigate } from "gatsby";
import {
  Combobox,
  ComboboxInput,
  ComboboxOptions,
  ComboboxOption,
} from "@headlessui/react";
import Layout from "../components/Layout";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Head as SeoHead } from "../utils/seoTags";

const NotFoundPage = () => (
  <Layout location="legal" uptitle="Proyectop" title="404 - No encontrado">
    <HeadingsSection />
  </Layout>
);

const HeadingsSection = () => {
  return (
    <section className="copy legal-page mb-20">
      <div className="container flex flex-col-reverse gap-8 items-center">
        <h2 className="text-uppercase">Ops... Aquí no hay nada</h2>
        <ExclamationTriangleIcon className="size-36" />
        <SearchAutocomplete />
      </div>
    </section>
  );
};

const SearchAutocomplete = () => {
  const [query, setQuery] = useState("");
  const [selectedPage, setSelectedPage] = useState(null);

  // Query para obtener páginas desde Strapi
  const data = useStaticQuery(graphql`
    query FooterPages {
      allStrapiPage(sort: { order: ASC }) {
        nodes {
          id
          title
          slug
          order
        }
      }
    }
  `);

  const pages = data.allStrapiPage.nodes;

  // Filtrar páginas según la consulta del usuario
  const filteredPages =
    query === ""
      ? []
      : pages.filter((page) =>
          page.title.toLowerCase().includes(query.toLowerCase())
        );

  // Navegar a la página seleccionada
  const handleSelect = (page) => {
    setSelectedPage(page);
    navigate(`/${page.slug}`);
  };

  return (
    <div className="w-full max-w-md">
      <Combobox value={selectedPage} onChange={handleSelect}>
        <div className="relative">
          <ComboboxInput
            className="w-full border p-2 rounded-md"
            placeholder="Busca una página..."
            onChange={(event) => setQuery(event.target.value)}
          />
          <ComboboxOptions className="absolute z-10 w-full bg-white border rounded-md shadow-md mt-1">
            {filteredPages.length > 0 ? (
              filteredPages.map((page) => (
                <ComboboxOption
                  key={page.id}
                  value={page}
                  className="p-2 cursor-pointer hover:bg-gray-100"
                >
                  {page.title}
                </ComboboxOption>
              ))
            ) : (
              <p className="p-2 text-gray-500">No se encontraron resultados</p>
            )}
          </ComboboxOptions>
        </div>
      </Combobox>
    </div>
  );
};

export const Head = (props) => (
  <SeoHead {...props} title="404 - No Encontrado" />
);

export default NotFoundPage;
